import { render, staticRenderFns } from "./PaperlessManagementTable.vue?vue&type=template&id=6feff76c&scoped=true&"
import script from "./PaperlessManagementTable.vue?vue&type=script&lang=ts&"
export * from "./PaperlessManagementTable.vue?vue&type=script&lang=ts&"
import style0 from "./PaperlessManagementTable.vue?vue&type=style&index=0&id=6feff76c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feff76c",
  null
  
)

export default component.exports